var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Typography, Button, Descriptions, message as antdMessage } from 'antd';
import { Permissions } from '@whatsper/texterchat-common';
import { useStore } from '../../../../store/rootStore';
import moment from 'moment';
import { Trans } from 'react-i18next';
import styles from './ChannelNotification.module.scss';
const { Text } = Typography;
const ChannelNotification = ({ notification }) => {
    const { agentsStore, channels } = useStore();
    const problem = notification.source;
    const [isLoading, setIsLoading] = useState(false);
    if (!problem) {
        return null;
    }
    const resolveProblem = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const response = yield channels.resolveChannelHealthProblem(problem._id);
            if (response.status === 200) {
                antdMessage.success(React.createElement(Trans, { i18nKey: "problemResolvedSuccessfully" }));
            }
            else {
                antdMessage.error(React.createElement(Trans, { i18nKey: "failedToResolveProblem" }));
            }
        }
        catch (error) {
            console.error('Failed to resolve problem:', error);
        }
        finally {
            setIsLoading(false);
        }
    });
    const { accountId, channel, createdAt, impairedFunctionality, instruction, message, name, severity, startedAt } = problem;
    const { send, receive, contactPhoneNumber } = impairedFunctionality || {};
    return (React.createElement("div", { className: styles.container },
        React.createElement(Descriptions, { bordered: true, size: "small", column: 1 },
            React.createElement(Descriptions.Item, { label: "Name" }, name),
            React.createElement(Descriptions.Item, { label: "Message" }, message),
            React.createElement(Descriptions.Item, { label: "Channel" }, channel),
            accountId && React.createElement(Descriptions.Item, { label: "Account ID" }, accountId),
            React.createElement(Descriptions.Item, { label: "Severity" }, severity),
            startedAt && (React.createElement(Descriptions.Item, { label: "Started At" }, moment(startedAt).format('LLL'))),
            createdAt && (React.createElement(Descriptions.Item, { label: "Created At" }, moment(createdAt).format('LLL'))),
            instruction && React.createElement(Descriptions.Item, { label: "Instruction" }, instruction),
            Object.keys(impairedFunctionality || {}).length > 0 && (React.createElement(Descriptions.Item, { label: "Impaired Functionality" },
                send !== undefined && (React.createElement(Text, null,
                    "Send: ",
                    send ? 'Yes' : 'No',
                    React.createElement("br", null))),
                receive !== undefined && (React.createElement(Text, null,
                    "Receive: ",
                    receive ? 'Yes' : 'No',
                    React.createElement("br", null))),
                contactPhoneNumber && React.createElement(Text, null,
                    "Contact Phone: ",
                    contactPhoneNumber)))),
        agentsStore.hasPermissions([Permissions.Permission.channels_manage]) && (React.createElement("div", { className: styles.actions },
            React.createElement(Button, { type: "primary", onClick: resolveProblem, loading: isLoading },
                React.createElement(Trans, { i18nKey: "resolveProblem" }))))));
};
export default observer(ChannelNotification);
